import React from 'react';
import { MultiAuto } from 'fw/forms';
import * as API from 'modules/app/API';

// NVBDC-1404 — multi-select, search-as-you-type NAICS picker for the one-sheet's NAICS popup.
// Reuses the same lookup endpoint the classic wizard's single-select NaicsCodeAuto already uses
// (areas/shared/controls/naicsCodeAuto/NaicsCodeAuto.js), just wrapped with MultiAuto instead of
// Auto so several codes can be searched, picked, and removed as chips in one control.
class NaicsCodeMultiAuto extends React.Component {
    NAICSCodeLoader = () => {
        return {
            url: API.App.url('/lookup/lookupNAICSCode'),
            params: {}
        };
    };

    render() {
        return (
            <MultiAuto
                {...this.props}
                loader={this.NAICSCodeLoader}
                placeholder={this.props.placeholder}
            />
        );
    }
}

export default NaicsCodeMultiAuto;

// Mark this as a form component
NaicsCodeMultiAuto.defaultProps = {
    formControl: true,
    managed: false,
    placeholder: 'Search NAICS Code(s)...'
};



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/controls/NaicsCodeMultiAuto.js